import chatbotRequest from '@/service/channel/http'
import type { DashboardInfoReq, DashboardInfoRes } from '../type/getDashboardInfo'

export function getDashboardInfoApi(data: DashboardInfoReq): Promise<DashboardInfoRes> {
    return chatbotRequest<DashboardInfoRes, DashboardInfoReq, DashboardInfoRes>({
        url: '/api/dashboard/info',
        method: 'post',
        data,
    })
}